if (window.Shopify && Shopify.designMode) {
    // Theme editor me kuch mat karo
} else {
    let windowWidth = window.innerWidth;

    window.addEventListener('resize', function() {

        if (document.fullscreenElement) return;

        if (window.innerWidth !== windowWidth) {
            location.reload();
        }

    });
}

$(document).ready(function () {
  let lastScrollTop = 0;
  const header = $('.main-header');

  function isDesktop() {
    return window.matchMedia("(min-width: 1200px)").matches;
  }

  function updateBodyPadding() {
    if (header.hasClass('sticky')) {
      $('body').css('padding-top', header.outerHeight());
    } else {
      $('body').css('padding-top', 0);
    }
  }

  $(window).on('scroll', function () {
    if (!isDesktop()) return;

    let currentScroll = $(this).scrollTop();

    if (currentScroll > 300) {
      if (!header.hasClass('sticky')) {
        header.addClass('sticky');
      }

      updateBodyPadding();

      if (currentScroll > lastScrollTop) {
        header.addClass('hide'); // scroll down
      } else {
        header.removeClass('hide'); 
      }
    } else {
      header.removeClass('sticky hide');
      updateBodyPadding(); 
    }

    lastScrollTop = currentScroll;
  });

  $(window).on('resize', function () {
    if (!isDesktop()) {
      header.removeClass('sticky hide');
    }
    updateBodyPadding(); 
  });
});


// === BREEZE VARIANT HANDLER ===
(function() {
  'use strict';
  
  function updateBreezeButton(variant) {
    const breezeButton = document.querySelector('.product-form_breezeButton');
    
    if (!breezeButton) return;
    
    if (!variant) {
      breezeButton.setAttribute('enable', 'false');
      breezeButton.style.display = 'none';
    } else {
      const isAvailable = variant.available;
      breezeButton.setAttribute('enable', isAvailable.toString());
      breezeButton.style.display = isAvailable ? 'block' : 'none';
      breezeButton.setAttribute(
        "selectedproductvariantdata",
        btoa(JSON.stringify(variant))
      );
    }
  }
  
  // Listen for variant changes
  document.addEventListener('variant:change', function(event) {
    if (event.detail && event.detail.variant) {
      updateBreezeButton(event.detail.variant);
    }
  });
  
  document.addEventListener('variantChange', function(event) {
    if (event.detail && event.detail.variant) {
      updateBreezeButton(event.detail.variant);
    }
  });
  
})();
// === END BREEZE VARIANT HANDLER ===